import { Button, Drawer, Typography } from '@navi/web-ui/lib/primitives';
import { Dispatch, SetStateAction } from 'react';
import ErrorIconOutline from '@cp/src/assets/icons/ErrorIconOutline';

interface EditAgentDrawerProps {
  isDrawerOpen: boolean;
  onClose: () => void;
  setShowLoader: Dispatch<SetStateAction<boolean>>;
  toggleOutsideClick: () => void;
  isDirtyField: boolean;
  isOutsideClick: boolean;
  handleSubmitClick: () => void;
  isSubmitButtonDisabled: boolean;
  handleExitYesClick: () => void;
  handleExitNoClick: () => void;
  section?: JSX.Element;
  showActionButton: boolean;
}

const EditAgentDrawer = (props: EditAgentDrawerProps) => {
  const {
    isDrawerOpen,
    onClose,
    toggleOutsideClick,
    isDirtyField,
    isOutsideClick,
    handleSubmitClick,
    isSubmitButtonDisabled,
    handleExitYesClick,
    handleExitNoClick,
    section,
    showActionButton
  } = props;
  return (
    <>
      <Drawer
        open={isDrawerOpen}
        onClose={toggleOutsideClick}
        headerText="Edit details"
        showHeaderDivider={true}
        usePadding={false}
        style={{ width: '400px' }}
        contentClasses="overflow-auto"
        onOutSideClick={toggleOutsideClick}
        disableOutsideClick={isDirtyField ? true : false}
        footerContainerClasses={isOutsideClick ? '!bg-[var(--navi-color-red-bg)]' : ''}
        footer={
          !isOutsideClick
            ? showActionButton && (
                <div className={'gap-2'}>
                  <Button
                    variant="secondary"
                    onClick={isDirtyField ? toggleOutsideClick : onClose}
                    size="medium"
                    className="px-[60px]"
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="primary"
                    type="submit"
                    size="medium"
                    onClick={handleSubmitClick}
                    className="px-[40px] ml-5"
                    disabled={isSubmitButtonDisabled || !isDirtyField}
                  >
                    Save changes
                  </Button>
                </div>
              )
            : showActionButton && (
                <div className={'flex'}>
                  <div className="w-[20px] pt-[2px]">
                    <ErrorIconOutline />
                  </div>
                  <div className="items-center">
                    <div>
                      <Typography variant="h5" color="var(--navi-color-red-base)">
                        Your changes will not be saved. Are you sure you want to exit?
                      </Typography>
                    </div>
                    <div className="mt-2">
                      <Button
                        variant="secondary"
                        size="small"
                        className="mr-4"
                        onClick={handleExitYesClick}
                      >
                        Yes
                      </Button>
                      <Button
                        variant="primary"
                        type="submit"
                        size="small"
                        onClick={handleExitNoClick}
                      >
                        No
                      </Button>
                    </div>
                  </div>
                </div>
              )
        }
      >
        <div>
          <section>{section}</section>
        </div>
      </Drawer>
    </>
  );
};

export default EditAgentDrawer;
